module.exports = __webpack_public_path__ + "static/media/people-loan.2804888f.svg";